<!-- 汇率查询 -->
<template>
  <div class="interOrderCash">
    <order-search
      ref="orderSearch"
      :searchColumns="searchColumns"
      :searchForm="searchForm"
      :columnList="columnList"
      :reserve="true"
      :api="api"
      :rules="rules"
      type="cash"
      @searchCompanyChange="searchCompanyChange"
      @searchOrderChange="searchOrderChange"
      :showFooter="1 == 1"
      :footerTotalCols="footerTotalCols"
    ></order-search>
  </div>
</template>

<script>
  import { baseRules } from '../components/rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  import orderSearch from '../components/orderSearch';
  // import InputNumber from '@/components/form-item/input-number';
  import IG_API from '@/api/masterData/intersetGroup.js';
  export default {
    name: 'interOrderCash',
    components: {
      orderSearch,
      // InputNumber,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('interOrderPool.column.orderCompany'),
            prop: 'orderCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'searchCompanyChange',
            filterable: true,
          },
          {
            // 部门
            prop: 'orderDepartmentCode',
            name: this.$t('interOrderPool.column.orderDepartment'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            name: this.$t('interOrderPool.search.orderDateStart'),
            prop: 'orderDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('interOrderPool.search.orderDateEnd'),
            prop: 'orderDateEnd',
            type: 'endDaterangePicker',
          },
          {
            name: this.$t('interOrderPool.column.order'),
            prop: 'orderCode',
            type: 'select',
            options: this.orderList,
            clearable: true,
            filterable: true,
            changeMethod: 'searchOrderChange',
          },
          {
            name: this.$t('interOrderPool.column.event'),
            prop: 'eventCode',
            type: 'select',
            options: this.eventList,
            clearable: true,
            filterable: true,
          },
          {
            name: this.$t('interOrderPool.column.orderNo'),
            prop: 'orderNo',
            type: 'input',
            clearable: true,
          },
          {
            // 部门组
            prop: 'interestGroupCodes',
            name: '部门组',
            type: 'ajaxSelect',
            apiUrl: IG_API.INTERSET_GROUP_LIST,
            apiData: {},
            clearable: true,
            filterable: true,
            valueKey: 'interestGroupCode',
            labelKey: 'interestGroupName',
            method: 'post',
            multiple: true,
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'orderCompanyName',
            title: this.$t('interOrderPool.column.orderCompany'),
          },
          {
            field: 'orderDepartmentName',
            title: this.$t('interOrderPool.column.orderDepartment'),
          },
          {
            field: 'orderInterestGroupName',
            title: '部门组',
          },
          {
            field: 'orderDate',
            title: this.$t('interOrderPool.column.orderDate'),
          },
          {
            field: 'orderCode',
            title: this.$t('interOrderPool.column.order'),
            formatter: this.formatOrderCode,
          },
          {
            field: 'eventName',
            title: this.$t('interOrderPool.column.event'),
          },
          {
            field: 'orderNo',
            title: this.$t('interOrderPool.column.orderNo'),
          },
          {
            field: 'paymentAmount',
            title: this.$t('interOrderPool.column.paymentAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.paymentAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.paymentAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'paymentAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'receiptAmount',
            title: this.$t('interOrderPool.column.receiptAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.receiptAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.receiptAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'receiptAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'interestStatus',
            title: '计息状态',
            formatter: this.formatInterestStatus,
          },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: { price: ['paymentAmount', 'receiptAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        companyList: [],
        departmentList: [],
        orderList: [],
        eventList: [],
        api: {
          query: 'QUERY_INTRORDERCASH_PAGE',
          save: 'SAVE_INTRORDERCASH',
          export: 'EXPORT_INTRORDERCASH',
          cal: 'CAL_INTRORDERCASH',
        },
        rules: baseRules,
        searchForm: {
          orderCompanyCode: null,
          orderDepartmentCode: null,
          orderDateStart: null,
          orderDateEnd: null,
          orderCode: 'CASH',
          eventCode: null,
          interestGroupCodes: null,
          orderNo: null,
        },
      };
    },
    mounted() {
      this.getCompany();
      this.getOrder();
      if (Object.keys(this.$route.query).length > 0) {
        let query = this.$route.query;
        this.searchForm.orderCode = query.orderCode;
        this.searchForm.orderCompanyCode = query.orderCompanyCode;
        if (query.departmentType === '1') {
          this.searchForm.interestGroupCodes = [query.orderDepartmentCode];
        } else {
          this.searchForm.orderDepartmentCode = query.orderDepartmentCode;
        }
        this.searchForm.orderDateStart = this.searchForm.orderDateEnd = query.interestDate;
        this.getDepartment(this.searchForm.orderCompanyCode);
        console.log(this.searchForm.orderCode);
        this.$refs.orderSearch.searchBtnClick();
      }
      this.getEvent(this.searchForm.orderCode);
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      formatOrderCode({ cellValue }) {
        return this.orderList.length > 0
          ? this.orderList.find((item) => cellValue == item.value).label
          : null;
      },
      formatInterestStatus({ cellValue }) {
        return cellValue
          ? this.$refs.orderSearch.interestStatusOption.find((item) => cellValue == item.value)
              .label
          : null;
      },
      // 获取公司数据
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      // 获取部门数据
      async getDepartment(companyCode) {
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.departmentList = res;
          }
        } else {
          this.departmentList = [];
        }
      },
      // 获取业务单据类型数据
      async getOrder() {
        let res = await this.$axios.post(API.QUERY_ORDERTYPE);
        if (res && res.data.code == 0) {
          this.orderList = res.data.data;
          this.orderList = this.orderList.map((item) => {
            return { value: item.orderCode, label: item.orderName };
          });
        }
      },
      // 获取事件类型数据
      async getEvent(orderCode) {
        let res = await this.$axios.post(API.QUERY_INTERESTEVENTTYPE, { orderCode });
        if (res && res.data.code == 0) {
          this.eventList = res.data.data;
          this.eventList = this.eventList.map((item) => {
            return { value: item.eventCode, label: item.eventName };
          });
        }
      },
      searchCompanyChange(val) {
        // 切换公司
        this.searchForm.orderDepartmentCode = null;
        this.getDepartment(val);
      },
      searchOrderChange(val) {
        this.getEvent(val);
      },
    },
  };
</script>
